import {Component, Inject, NgZone} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';

import {Globals} from '../../../globals';
import {UserService} from '../../../services/user.service';
import {SchedulerService} from '../scheduler.service';
import { DoctorListModelV2} from '../../../models/appointments/dataAppointmentWaitList.model';
import {MatSelectModule} from '@angular/material/select';


@Component({
    selector: 'app-wait-list-dialog-v2',
    templateUrl: './wait-list-dialog-v2.component.html',
    styleUrls: ['./wait-list-dialog-v2.component.scss']
})
export class WaitListDialogV2Component {

    listofApptsOnWaitList: any[] = [];
    DoctorList: DoctorListModelV2[];
    selectedDoctor: any;

    sortOptions: any[] = [{id: 1, name: 'Sort by Request date'}, {id: 2, name: 'Sort by referring doctor'}];
    selectedSortOption: number = 0;
    searchText: string = '';


    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                private snackBar: MatSnackBar,
                private dialogRef: MatDialogRef<WaitListDialogV2Component>,
                private schedulingService: SchedulerService,
                public globals: Globals,
                public dialog: MatDialog,
                private ngZone: NgZone,
                private userService: UserService) {

    }

    ngOnInit(): void {
        this.loadData();

    }

    loadData(): void {
        this.schedulingService.getAppointmentWaitList().subscribe(result => {
            if (result) {

                this.listofApptsOnWaitList = result;
                console.log('wait list', result);


                const doctorList: DoctorListModelV2[] = [];
                this.listofApptsOnWaitList.forEach(a => {

                    const l = doctorList.findIndex(f => f.DoctorId === a.Label_DoctorId);
                    if (l < 0) {


                        const b = new DoctorListModelV2();
                        b.DoctorId = a.Label_DoctorId;
                        b.DoctorFullName = a.Doctor_FullName;
                        doctorList.push(b);

                    }


                });

                setTimeout(() => {
                    this.ngZone.run(() => {
                        this.DoctorList = doctorList;
                        this.selectedDoctor = this.DoctorList[0].DoctorId;
                        console.log('doctors ', this.DoctorList);
                    });
                }, 1000);


            }
        });

    }



    onDeletClick(i) {


        this.schedulingService.removeAppoitmentFromWaitList(i.AppointmentId).subscribe(res => {

            this.loadData();

        });

    }

    onReschedClick(i) {


        this.globals.RescheduleAppointmentRequest = {
            AppointmentId: i.AppointmentId,
            Patient_FullName: i.Patient_FullName,
            Reschedule_Note: i.Description
        };
        this.dialogRef.close(true);
    }

    onOpenClick(i) {

    }
}
